import { Button, Column, Columns } from '@codeparva/ui-components-library';
import { navigate } from 'gatsby';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { SectionContentSubTitle } from '../../../../components/textVariations';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import {
  desktopscreensize,
  tabletscreensize,
} from '../../../../utilities/constants';
import { Icon } from '../../../../utilities/icomoon-css/index';
import { weakKey } from '../../../../utilities/weakKey';
import { AccountPanelTypes } from '../../AccountPanelTypes';
import { ExitModal, LocationSection } from '../../helpers/LayoutComponents';
import {
  currentPageHeadline,
  sideBarConfig,
} from '../../helpers/LayoutSideBarConfig';
import { OutSideClick } from '../../helpers/OutsideClick';
import {
  makeBackgroundClickable,
  makeModalBackgroundUnClickable,
} from '../../helpers/accountPanelModalHelper';
import { SideNavBar } from './SideBar';

export const AccountPanelLayout = ({
  ledgerList,
  children,
  currentLedgerId,
  locationName,
  logOutHandler,
  bodyHeight,
}: AccountPanelTypes.TLayout) => {
  const { width } = useWindowDimensions();
  const [hideSideNavbar, setShowHideSideNavBar] = useState(
    width <= tabletscreensize ? true : false
  );
  const [
    detectedOutsideClickSidebar,
    setDetectedOutsideClickSidebar,
  ] = useState(false);
  const [showExistModal, setShowExistModal] = useState(false);
  const userSectionRef = useRef<any>();
  const sideBarRef = useRef<any>();
  const switchSideBarRef = useRef<any>();
  const clickedOutsideSidebar =
    width < tabletscreensize ? OutSideClick(sideBarRef) : '';
  const currPage = location.pathname.substring(
    location.pathname.lastIndexOf('/') + 1
  );
  const [isOpen, setIsOpen] = useState(false);
  const [currLedgerLabel, setCurrLedgerLabel] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isBurgerEnabled, setIsBurgerEnabled] = useState(false);

  useEffect(() => {
    if (width < desktopscreensize) setIsBurgerEnabled(true);
  }, [width]);

  useEffect(() => {
    const getLabelById = (ledgerList: any[], id: string | undefined) => {
      const ledger = ledgerList.find(ledger => ledger.id === id);
      return ledger ? ledger.label : null;
    };
    if (currentLedgerId && ledgerList.length > 0) {
      setCurrLedgerLabel(getLabelById(ledgerList, currentLedgerId));
    }
  }, [currentLedgerId, ledgerList]);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current?.contains(event?.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(prevState => !prevState);
  };

  const updateSelectedLedger = (value: string) => {
    if (isNaN(currPage as any)) {
      navigate(`../../${value}`, {
        state: { prevPage: currPage },
        replace: true,
      });
    } else {
      navigate(`../../${value}`, {
        replace: true,
      });
    }
    setIsOpen(false);
  };

  useEffect(() => {
    if (showExistModal) {
      makeModalBackgroundUnClickable();
    } else if (!showExistModal) {
      makeBackgroundClickable();
    }

    if (width <= tabletscreensize && hideSideNavbar === false) {
      setDetectedOutsideClickSidebar(true);
      setShowHideSideNavBar(true);
    } else if (detectedOutsideClickSidebar === true) {
      setDetectedOutsideClickSidebar(false);
    }

    return () => {
      document.body.style.overflowY = '';
      document.body.style.position = 'static';
    };
  }, [showExistModal, clickedOutsideSidebar]);

  const logOutLinkHandler = () => {
    setShowExistModal(!showExistModal);
  };

  const closeSideNavBar = () => {
    setShowHideSideNavBar(true);
  };

  const handleViewAccountsNavigation = () => {
    navigate('../../account-selection', {
      replace: true,
    });
  };

  const RenderSideBar = useCallback(() => {
    if (hideSideNavbar || detectedOutsideClickSidebar) {
      return <></>;
    } else {
      return (
        <SideNavBar
          sideBarConfig={sideBarConfig}
          currRef={sideBarRef}
          locationName={locationName}
          closeSideNavBar={closeSideNavBar}
          logOutHandler={logOutHandler}
          bodyHeight={bodyHeight}
          logOutLinkClickHandler={logOutLinkHandler}
        />
      );
    }
  }, [hideSideNavbar, detectedOutsideClickSidebar]);

  const LedgerDropdownList = useCallback(() => {
    return (
      <>
        <div className="dropdown-content dropdownContentContainer">
          {ledgerList?.map(
            (indivLedger: { id: string; label: string }, index: number) => (
              <>
                <div
                  onClick={() => updateSelectedLedger(indivLedger.id)}
                  className={`indivLedger dropdown-item is-flex is-justify-content-center p-2 cursorPointer`}
                  key={weakKey({ indivLedger })}
                >
                  <p className="is-flex is-align-items-center">
                    {indivLedger.label}
                  </p>
                </div>
                {index < ledgerList.length - 1 ? (
                  <hr className="my-2 mx-0" />
                ) : (
                  <></>
                )}
              </>
            )
          )}
        </div>
        <hr className="m-0" />
        <div className="is-flex is-justify-content-center dropdown-content pt-0">
          <Button
            className="m-2"
            onClick={handleViewAccountsNavigation}
            style={{ height: '3rem' }}
          >
            View all accounts
          </Button>
        </div>
      </>
    );
  }, [currentLedgerId, ledgerList]);

  const RenderLedgerDropdown = () => {
    return (
      <div className="dropdown" ref={dropdownRef}>
        <div className="dropdown-trigger">
          <div
            className="switchLedgerSubMenu is-flex is-align-items-center is-justify-content-space-between p-3 cursorPointer"
            ref={switchSideBarRef}
            onClick={toggleDropdown}
            style={{
              ...(!isBurgerEnabled
                ? { minWidth: '20rem', border: '1px solid #cccccc' }
                : { marginRight: '1rem' }),
            }}
          >
            <div className="labelSection is-flex is-align-items-center">
              <Icon
                name={'tfw-profile-circle-cp'}
                size={24}
                title={'profile-circle-cp'}
                color={isBurgerEnabled ? 'white' : 'black'}
              />
              {!isBurgerEnabled && (
                <div className="ml-4">
                  <p className="subtitle1">{currLedgerLabel}</p>
                </div>
              )}
            </div>
            {!isBurgerEnabled && (
              <Icon
                name={
                  isOpen ? 'tfw-arrow-up-bold-2-cp' : 'tfw-arrow-down-bold-2-cp'
                }
                size={24}
                title={'arrow-down-1'}
              />
            )}
          </div>
        </div>
        {isOpen && (
          <div
            className={`dropdownMenu${isOpen ? ' is-active' : ''}`}
            id="dropdown-menu"
            role="menu"
          >
            <LedgerDropdownList />
          </div>
        )}
      </div>
    );
  };

  const closeModal = () => {
    setShowExistModal(false);
  };

  return (
    <div className="accountParentContainer">
      <div className="accountContainer">
        <Columns className="layoutContainer">
          <Column className="navigationSection">
            <RenderSideBar />
            <Column className="container my-0 ml-0 layoutChildrenContainer">
              <div className="locationInfoAndSwitchSection">
                <LocationSection locationName={locationName} />
                <div className="smallScreenNavbar is-hidden-tablet">
                  <span
                    onClick={() =>
                      setShowHideSideNavBar(prevValue => !prevValue)
                    }
                  >
                    <Icon name="tfw-menu-outline-cp" size={24} title="menu1" />
                  </span>
                  <SectionContentSubTitle>
                    {currentPageHeadline()}
                  </SectionContentSubTitle>
                </div>
                <div className="ledgerDropdownContainer" ref={userSectionRef}>
                  <RenderLedgerDropdown />
                </div>
              </div>
              <div className="layoutChildren">{children}</div>
            </Column>
          </Column>
        </Columns>
        {showExistModal && (
          <ExitModal
            bodyHeight={bodyHeight}
            hideModal={closeModal}
            logOutHandler={logOutHandler}
          />
        )}
      </div>
    </div>
  );
};
